module.exports = __webpack_public_path__ + "img/weppa.7ec34a51.png";